import type { ErrorInfo } from 'react'

import { ddLogger } from '@b-stock/fe-core/bstock-react'

import useUserInfo from '@helpers/useUserInfo'

export const useLogError = () => {
  const { accountId, personId } = useUserInfo()

  const logError = (error: unknown, info: ErrorInfo) => {
    const additionalProps: { [key: string]: string | undefined } = {
      ...(accountId && { accountId }),
      ...(personId && { personId }),
    }

    ddLogger.error(
      'Caught error at react error boundary',
      { info, ...additionalProps },
      error instanceof Error
        ? error
        : new Error('Error not an instance of Error', { cause: error })
    )
  }

  return logError
}
